import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { setResourceViewerOpen } from '../../features/resourceViewer/resourceViewer';
import { setTeacherPendingActionsWidgetOpen } from '../../features/techerPendingActionsWidgetModal/teacherPendingActionsWidgetModalSlice';
import AssetViewer from '../book-viewer/AssetViewer';
import { RootState } from '../../store';
import { setAssetViewerOpen } from '../../features/assetViewer/assetViewerSlice';

export const ResourceViewer: React.FC = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const resourceId = searchParams.get('id') || '';
    const dispatch = useDispatch();
    const bookId = useSelector((state: RootState) => state.currentBook.bookId);

    useEffect(() => {
        dispatch(setTeacherPendingActionsWidgetOpen(false));
    }, []);
    useEffect(() => {
        dispatch(setResourceViewerOpen(true));
        return () => {
            dispatch(setResourceViewerOpen(false));
        };
    }, []);

    return (
        <div className="h-full w-full overflow-scroll">
            <AssetViewer
                isOpen={true}
                onClose={() => dispatch(setAssetViewerOpen(false))}
                type={''}
                resId={resourceId}
                resPath={''}
                bookUri={''}
                bookId={bookId || ''}
                source="resource viewer"
            />
        </div>
    );
};

export default ResourceViewer;
